import { render, staticRenderFns } from "./PlanesTratamientoForm.vue?vue&type=template&id=79344bd7"
import script from "./PlanesTratamientoForm.vue?vue&type=script&lang=js"
export * from "./PlanesTratamientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports